<template>
	<div>
		<div class="sense-main">
			<div class="sense-search">
				<el-row>
					<el-form label-width="68px">								
						<el-col :span="6" :offset="15">
							<el-form-item label="套餐名称">
								<el-input size="medium" v-model.trim="licenseSearchObj.packageName" maxlength="64"></el-input>
							</el-form-item>	
						</el-col>								
						<el-col :span="3" class="text-right">
							<el-button class="search-btn" size="medium" @click="emptyLicenseSearch">清空</el-button>
							<el-button class="search-btn" size="medium" type="primary" @click="searchLicenseList">搜索</el-button>
						</el-col>									
					</el-form>
				</el-row>
			</div>
			<div class="sense-table-list">
				<div class="package-no-data" v-if="isReady == true && licenseListData.length == 0 && !noDataObj.packageName">一大波优惠在路上，敬请期待</div>
				<div class="package-no-data" v-if="isReady == true && licenseListData.length == 0 && noDataObj.packageName">暂无数据</div>
				<el-row style="margin-right: -30px;">
					<el-col :span="8" v-for="item in licenseListData" :key="item.packageGuid">
						<el-card class="sense-card-new">
							<div slot="header" class="card-new-header clearfix">
								<h3 class="fl sense-ellipsis" :title="item.packageName">{{ item.packageName }}</h3>
								<el-popover placement="right-start" width="270" trigger="click">
									<el-form size="small" label-width="100px">
										<div v-if="item.packageType == 1">
											<el-form-item label="许可形式">
												<div class="sense-text">{{ item.detail.licenseForm | licenseFormFilter }}</div>						
											</el-form-item>	
											<el-form-item label="系统平台" v-if="item.detail.licenseForm==2">												
												<div class="sense-text" v-if="item.detail.platform == 7" style="position: relative;top: -2px;">
													传统 (
													<em title="Windows" class="ssicon ss-windows"></em>
													<em title="Linux" class="ssicon ss-linux"></em>
													<em title="Mac" class="ssicon ss-mac"></em>
													)
												</div>
												<div class="sense-text" v-if="(item.detail.platform & 24) > 0" style="position: relative;top: -2px;">
													智能(
													<em title="Android" class="ssicon ss-android"></em>
													<em title="ARM Linux" class="arm-linux-icon"></em>
													)
												</div>						
											</el-form-item>	
											<el-form-item label="许可周期">
												<div class="sense-text">{{ item.detail.licensePeriod | licensePeriodFilter }}</div>
											</el-form-item>		
											<el-form-item label="使用计数" v-if="item.detail.licenseForm==1">
												<div class="sense-text">{{ item.detail.useCount?item.detail.useCount:'--' }}</div>		
											</el-form-item>	
											<el-form-item label="许可类型" v-if="item.detail.licenseForm==2 && item.detail.platform == 7">
												<div class="sense-text">{{ item.detail.hasConcurrent | concurrentFilter(item.detail.concurrentType, item.detail.concurrent) }}</div>		
											</el-form-item>
											<el-form-item label="同时绑定数" v-if="item.detail.licenseForm==2 && ((item.detail.platform == 7 && item.detail.hasConcurrent==false) || (item.detail.platform & 24) > 0)">
												<div class="sense-text">{{ item.detail.bindLimit }}</div>		
											</el-form-item>		
											<el-form-item label="累积绑定数" v-if="item.detail.licenseForm==2 && item.detail.hasConcurrent==false && item.detail.platform == 7">
												<div class="sense-text">{{ item.detail.maxBound }}</div>			
											</el-form-item>	
											<el-form-item label="许可数量" style="margin-top: 10px;">
												<div class="sense-text">{{ item.detail.licenseCount | commonFilter }}</div>		
											</el-form-item>
										</div>										

										<el-form-item label="更新次数" v-if="item.packageType == 2">
											<div class="sense-text">{{ item.detail.updateCount | commonFilter }}</div>		
										</el-form-item>

										<div v-if="item.packageType == 3">
											<el-form-item label="计费方式">
												<div class="sense-text">{{ item.detail.chargeMode | chargeModeFilter }}</div>		
											</el-form-item>
											<el-form-item label="升级次数" v-if="item.detail.chargeMode == 1">
												<div class="sense-text">{{ item.detail.upgradeCount }}</div>		
											</el-form-item>
											<el-form-item label="硬件锁数量" v-if="item.detail.chargeMode == 2">
												<div class="sense-text">{{ item.detail.dongleCount }}</div>		
											</el-form-item>
											<el-form-item label="硬件锁周期" v-if="item.detail.chargeMode == 2">					
												<div class="sense-text">{{ item.detail.donglePeriod | donglePeriodFilter }}</div>
											</el-form-item>
										</div>

										<el-form-item label="套餐有效期">
											<div class="sense-text">{{ item.packagePeriod | packagePeriodFilter }}</div>
										</el-form-item>
										<el-form-item label="套餐失效日期">
											<div class="sense-text">{{ item.expireTime | expireTimeFilter }}</div>
										</el-form-item>	
										<el-form-item label="原价">
											<div class="sense-text"><del>&#65509;{{ item.originPrice }}</del></div>						
										</el-form-item>	
										<el-form-item label="套餐价">
											<div class="sense-text">&#65509;{{ item.packagePrice }}</div>						
										</el-form-item>
									</el-form>
									<span class="fr ssicon ss-info" slot="reference"></span>
								</el-popover>
							</div>
							<ul class="card-new-con" v-if="item.packageType == 1">
								<li class="plat" v-if="item.detail.licenseForm == 2">
									<em v-if="item.detail.platform == 7" title="Windows" class="ssicon ss-windows"></em>
									<em v-if="item.detail.platform == 7" title="Linux" class="ssicon ss-linux"></em>
									<em v-if="item.detail.platform == 7" title="Mac" class="ssicon ss-mac"></em>
									<em v-if="(item.detail.platform & 24) > 0" title="Android" class="ssicon ss-android"></em>
									<em v-if="(item.detail.platform & 24) > 0" title="ARM Linux" class="arm-linux-big-icon"></em>
								</li>
								<li class="clearfix">
									<label class="fl">许可形式</label>
									<span class="fl">{{ item.detail.licenseForm | licenseFormFilter }}</span>
								</li>															
								<li class="clearfix">
									<label class="fl">许可周期</label>
									<span class="fl">{{ item.detail.licensePeriod | licensePeriodFilter }}</span>
								</li>
								<li class="clearfix">
									<label class="fl">许可数量</label>
									<span class="fl">{{ item.detail.licenseCount | commonFilter }}</span>
								</li>
							</ul>
							<ul class="card-new-con" v-if="item.packageType == 2">										
								<li class="clearfix">
									<label class="fl">更新次数</label>
									<span class="fl">{{ item.detail.updateCount | commonFilter }}</span>
								</li>
								<li class="clearfix">
									<label class="fl">套餐有效期</label>
									<span class="fl">{{ item.packagePeriod | packagePeriodFilter }}</span>
								</li>
							</ul>
							<ul class="card-new-con" v-if="item.packageType == 3">	
								<li class="clearfix">
									<label class="fl">计费方式</label>
									<span class="fl">{{ item.detail.chargeMode | chargeModeFilter }}</span>
								</li>									
								<li class="clearfix" v-if="item.detail.chargeMode == 1">
									<label class="fl">升级次数</label>
									<span class="fl">{{ item.detail.upgradeCount }}</span>
								</li>
								<li class="clearfix" v-if="item.detail.chargeMode == 2">
									<label class="fl">硬件锁数量</label>
									<span class="fl">{{ item.detail.dongleCount }}</span>
								</li>
								<li class="clearfix" v-if="item.detail.chargeMode == 2 && item.detail.donglePeriod">
									<label class="fl">硬件锁周期</label>
									<span class="fl">{{ item.detail.donglePeriod | donglePeriodFilter }}</span>
								</li>
								<li class="clearfix" v-if="!item.detail.donglePeriod">
									<label class="fl">套餐有效期</label>
									<span class="fl">{{ item.packagePeriod | packagePeriodFilter }}</span>
								</li>
							</ul>
							<div class="card-new-footer clearfix">
								<b class="fl">&#65509;{{ item.packagePrice }}</b>
								<del class="fl">&#65509;{{ item.originPrice }}</del>
								<el-button size="small" type="primary" class="fr" plain @click="licenseBuy(item)">立即购买</el-button>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
			<div class="sense-table-pager" v-if="licenseObj.total>0">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="licenseObj.currentPage"
					:page-sizes="[9,18,27]"
					:page-size="licenseObj.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="licenseObj.total">
				</el-pagination>
			</div>
		</div>
		<div class="all-dialog">
			<!-- 许可套餐购买 -->
			<el-dialog class="sense-dialog" title="购买确认" :visible.sync="licenseBuyFormVisible">
				<el-form :model="licenseBuyForm" size="small" label-width="120px">
					<div v-if="licenseBuyForm.packageType == 1">
						<el-form-item label="套餐名称">
							<div class="sense-text">{{ licenseBuyForm.packageName }}</div>						
						</el-form-item>	
						<el-form-item label="许可形式">
							<div class="sense-text">{{ licenseBuyForm.detail.licenseForm | licenseFormFilter }}</div>						
						</el-form-item>	
						<el-form-item label="系统平台" v-if="licenseBuyForm.detail.licenseForm==2">						
							<div class="sense-text" v-if="licenseBuyForm.detail.platform == 7" style="position: relative;top: -2px;">
								传统 (
								<em title="Windows" class="ssicon ss-windows"></em>
								<em title="Linux" class="ssicon ss-linux"></em>
								<em title="Mac" class="ssicon ss-mac"></em>
								)
							</div>
							<div class="sense-text" v-if="(licenseBuyForm.detail.platform & 24) > 0" style="position: relative;top: -2px;">
								智能(
								<em title="Android" class="ssicon ss-android"></em>
								<em title="ARM Linux" class="arm-linux-icon"></em>
								)
							</div>						
						</el-form-item>
						<el-form-item label="许可周期">
							<div class="sense-text">{{ licenseBuyForm.detail.licensePeriod | licensePeriodFilter }}</div>
						</el-form-item>		
						<el-form-item label="使用计数" v-if="licenseBuyForm.detail.licenseForm==1">
							<div class="sense-text">{{ licenseBuyForm.detail.useCount?licenseBuyForm.detail.useCount:'--' }}</div>		
						</el-form-item>	
						<el-form-item label="许可类型" v-if="licenseBuyForm.detail.licenseForm==2 && licenseBuyForm.detail.platform == 7">
							<div class="sense-text">{{ licenseBuyForm.detail.hasConcurrent | concurrentFilter(licenseBuyForm.detail.concurrentType, licenseBuyForm.detail.concurrent) }}</div>		
						</el-form-item>
						<el-form-item label="同时绑定设备数" v-if="licenseBuyForm.detail.licenseForm==2 && ((licenseBuyForm.detail.platform == 7 && licenseBuyForm.detail.hasConcurrent==false) || (licenseBuyForm.detail.platform & 24) > 0)">
							<div class="sense-text">{{ licenseBuyForm.detail.bindLimit }}</div>		
						</el-form-item>		
						<el-form-item label="累积绑定设备数" v-if="licenseBuyForm.detail.licenseForm==2 && licenseBuyForm.detail.hasConcurrent==false && licenseBuyForm.detail.platform == 7">
							<div class="sense-text">{{ licenseBuyForm.detail.maxBound }}</div>			
						</el-form-item>	
						<el-form-item label="许可数量">
							<div class="sense-text">{{ licenseBuyForm.detail.licenseCount | commonFilter }}</div>		
						</el-form-item>
					</div>

					<el-form-item label="更新次数" v-if="licenseBuyForm.packageType == 2">
						<div class="sense-text">{{ licenseBuyForm.detail.updateCount | commonFilter }}</div>		
					</el-form-item>

					<div v-if="licenseBuyForm.packageType == 3">
						<el-form-item label="计费方式">
							<div class="sense-text">{{ licenseBuyForm.detail.chargeMode | chargeModeFilter }}</div>		
						</el-form-item>
						<el-form-item label="升级次数" v-if="licenseBuyForm.detail.chargeMode == 1">
							<div class="sense-text">{{ licenseBuyForm.detail.upgradeCount }}</div>		
						</el-form-item>
						<el-form-item label="硬件锁数量" v-if="licenseBuyForm.detail.chargeMode == 2">
							<div class="sense-text">{{ licenseBuyForm.detail.dongleCount }}</div>		
						</el-form-item>
						<el-form-item label="硬件锁周期" v-if="licenseBuyForm.detail.chargeMode == 2">
							<div class="sense-text">{{ licenseBuyForm.detail.donglePeriod | donglePeriodFilter }}</div>
						</el-form-item>
					</div>

					<el-form-item label="套餐有效期">
						<div class="sense-text">{{ licenseBuyForm.packagePeriod | packagePeriodFilter }}</div>
					</el-form-item>
					<el-form-item label="套餐失效日期">
						<div class="sense-text">{{ licenseBuyForm.expireTime | expireTimeFilter }}</div>
					</el-form-item>	
					<el-form-item label="原价">
						<div class="sense-text"><del>&#65509;{{ licenseBuyForm.originPrice }}</del></div>						
					</el-form-item>	
					<el-form-item label="套餐价">
						<div class="sense-text">&#65509;{{ licenseBuyForm.packagePrice }}</div>						
					</el-form-item>
					<el-form-item style="margin-bottom: 0;">
						<div class="sense-tip-blue">点击“确定”按钮将从您的账户中扣除相应费用</div>						
					</el-form-item>		
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="licenseBuyFormVisible = false">取 消</el-button>
					<el-button type="primary" size="small" @click="licenseBuyFormSubmit">确 定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				tabsActive: '1',
				//许可套餐				
				licenseSearchObj: {
					packageName: ''
				},
				licenseObj: {
					currentPage: 1,
					pageSize: 9,
					total: 0
				},
				noDataObj: {
					packageName: ''
				},
				isReady: false,
				licenseListData: [],
				licenseBuyFormVisible: false,
				licenseBuyForm: {},
			}
		},
		filters: {
			//许可形式filter
			licenseFormFilter: function(val) {
				if (val == 1) {
					return '云锁';
				} else {
					return '软锁';
				};
			},
			//许可周期filter
			licensePeriodFilter: function(val) {
				if (val == 2147483647) {
					return '永久';
				} else {
					return val + '天';
				};
			},
			//硬件锁周期filter
			donglePeriodFilter: function(val) {
				if (val) {
					return val + '天';
				} else {
					return '--';
				};
			},
			//套餐有效期filter
			packagePeriodFilter: function(val) {
				if (val == 2147483647) {
					return '--';
				} else {
					return val + '天';
				};
			},
			//套餐失效日期filter
			expireTimeFilter: function(val) {
				if (!val) {
					return '--';
				} else {
					return val;
				};
			},
			//计费方式filter
			chargeModeFilter: function(val) {
				if (val == 1) {
					return '按升级次数';
				} else if (val == 2) {
					return '按锁数量';
				} else {
					return '不限';
				};
			},
			commonFilter: function(val) {
				if (val == 2147483647) {
					return '不限';
				} else {
					return val;
				};
			},
			//并发方式filter
			concurrentFilter: function(hasConcurrent, concurrentType, concurrent) {
				if (hasConcurrent == false) {
					return '单机许可';
				} else {
					var concurrentTypeName = concurrentType=='process'?'进程':'会话';
					return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
				};
			},
		},
		methods: {
			//许可套餐start
			getLicenseList() {
				let url = '/package/find.do';
				let param = this.licenseSearchObj;
				param.currentPage = this.licenseObj.currentPage;
				param.pageSize = this.licenseObj.pageSize;

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.licenseListData = response.data.rows;
						this.licenseObj.total = response.data.records;
						this.noDataObj.packageName = this.licenseSearchObj.packageName;
						this.isReady = true;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});		
			},
			//许可套餐购买
			licenseBuy(item) {
				this.licenseBuyForm = item;
				this.licenseBuyFormVisible = true;
			},
			//许可套餐购买确定
			licenseBuyFormSubmit() {
				let url = '/package/buy.do';
				let param = {
					packageGuid: this.licenseBuyForm.packageGuid
				};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.licenseBuyFormVisible = false;
						this.$message({
							message: '套餐购买成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});
			},	
			//搜索
			searchLicenseList() {
				this.licenseObj.currentPage = 1;
				this.getLicenseList();
			},
			//清空
			emptyLicenseSearch() {
				this.licenseSearchObj.packageName = '';
				this.licenseObj.currentPage = 1;
				this.getLicenseList();
			},	
			//切换每页显示条数
			handleSizeChange(val) {
				this.licenseObj.pageSize = val;
				this.getLicenseList();
			},
			//切换当前页
			handleCurrentChange(val) {
				this.licenseObj.currentPage = val;
				this.getLicenseList();
			},
			//许可套餐end
		},
		mounted() {
			this.getLicenseList();
		},
	}
</script>

<style lang="scss">	

</style>


// WEBPACK FOOTER //
// Package.vue?48530df3